import { memo, useCallback, useMemo, useState } from "react";
import { getGridAllRows } from "../utils/global_functions";

const GridHeaderCheckbox = ({ ...props }) => {

    const rowsSelected = useMemo(() => {
        return props.api.getSelectedRows();
    }, [props.api]);

    const [isChecked, setIsChecked] = useState(getGridAllRows(props?.api)?.length === props.api.getSelectedRows()?.length ? true : false);

    const handleChange = useCallback((event) => {
        if (props.api.getSelectedRows()?.length > 0) {
            setIsChecked(false);
            props.api.deselectAll('all');
        } else {
            setIsChecked(true);
            props.api.selectAll('all');
        }
    }, [props]);

    return <input checked={isChecked} type="checkbox" onChange={(e) => handleChange(e)} />;
};

export default memo(GridHeaderCheckbox);